import { setRangeMin } from './helpers';

export const setBathroomCountMin = setRangeMin('wc');
